export default __webpack_public_path__ + "static/media/wedding-1.33ba1fa8.jpg";